module.exports = __webpack_public_path__ + "static/media/mint.d668a8fc.png";